module.exports = __webpack_public_path__ + "img/course-preview-default.7e653a71.jpg";